<template>
  <section>
    <div class="container">
      <div class="grid">
        <footerLinks></footerLinks>
        <socialMedia></socialMedia>

        <p>
          <small
            >&copy; Copyright 2018 {{ addressCompanyName }}. Registered in England and Wales No.
            {{ addressCompanyRegistrationNumber }}. All rights reserved. Address for all correspondence and
            queries: {{ addressCompanyName }}, First Floor, Unit 4 Faraday Court, Centrum 100
            Business Park, First Ave, Burton-Upon-Trent, Staffordshire, DE14
            2WX. Registered under the Data Protection
            Act.{{ addressCompanyName }} - Registration No.Z2953491.</small
          >
        </p>

        <gambleAware></gambleAware>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import footerLinks from "../components/FooterLinks.vue";
import socialMedia from "../components/FooterSocialMedia.vue";
import gambleAware from "../components/GambleAware.vue";
import { TenantConfigService } from "../services/tenant-config-service";

export default defineComponent({
  name: "home",
  components: {
    footerLinks,
    socialMedia,
    gambleAware,
  },
  setup() {
    const tenantConfigService = TenantConfigService.getInstance();

    const addressCompanyName = computed(
      () => tenantConfigService.company.name
    );

    const addressCompanyRegistrationNumber = computed(
      () => tenantConfigService.company.registrationNumber
    );

    return {
      addressCompanyName,
      addressCompanyRegistrationNumber,
    };
  },
});
</script>

<style scoped>
    section {
        border-top: 4px solid var(--tenant-secondary-color);
        
        background-color: var(--tenant-primary-color);
    }

.container {
  max-width: min(100% - 30px, 1000px);
  display: grid;
  margin-inline: auto;
  padding-block: 1rem;
}

small {
  color: white;
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}
</style>
